export default "/static/media/device-background.4b9a445a.png";